import { Injectable } from '@angular/core';
//import toastr from 'toastr';
 import * as toastr_ from 'toastr';
 const toastr = toastr_;

@Injectable({
	providedIn: 'root'
})
export class MessageUtilService {
	message = '';
	constructor() { }

	getMessageError(codigo: string, element: string = '', message?: string): any {
		// tslint:disable: indent
		switch (codigo) {
			case 'A001':
				this.message = `El campo ${element}  es requerido`;
				break;
			case 'A002':
				this.message = `El campo ${element} no cumple con el formato establecido`;
				break;
			case 'A003':
				this.message = `La fecha ingresada no puede ser superior a la fecha del dí­a actual`;
				break;
			case 'A004':
				this.message = `La fecha del documento no puede ser menor a la fecha del ultimo documento ingresado`;
				break;
			case '000046':
				this.message = `${message}`;
				break;
			case 'A005':
				this.message = `No ha ingresado la serie`;
				break;
			case 'A999':
				this.message = `${element}`;
				element = 'Error';
				// return toastr.error(this.message);
				break;
			case '500':
				this.message = `Por favor comuniquese con el soporte del Sistema`;
				break;
			default:
				this.message = element;
				break;
		}
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true
		};
		toastr['error'](this.message, `<h5 class='text-white'> ${element} </h5>`);
		return toastr;
	}

	getAlertWarning(mensaje: string): any{
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true
		};
		toastr['warning'](mensaje);
		return toastr;
	}

	getAlertSuccess(mensaje: string): any{
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true
		};
		toastr['success'](mensaje);
		return toastr;
	}


}
